import React from "react";
import Routing from "./components/Routing";

const App = () => {
  return (
      <Routing />
  );
};

export default App;
